/**Dependencies */
import { useState, useEffect } from "react";

/**Components */
import { SectionAdvise } from "../components/SectionAdvise";
import { BannerParallax } from "../components/BannerParallax";

/**Styles */
import "../styles/hotel.scss";

/**Images */
import { PrincipalBanner } from "../components/PrincipalBanner";
import parallaxHotel from "../images2/parallax-hoteles.png";
import { CarouselCards } from "../components/CarouselCards";
import { getAllDestinations } from "../services/adminProductService";
import { CarruselHotels } from "../components/CarruselHotels";
import { useLocation } from "react-router-dom";
import { CheckOutCart } from "../components/CheckOutCart";
export const Hotels = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [showAlert, setShowAlert] = useState(false);
  const [arrSession, setArrSession] = useState(
    JSON.parse(sessionStorage.getItem("datosReserva")) || []
  );
  const today = new Date();
  const [destinations, setDestinations] = useState([]);
  const [dates] = useState([
    new Date(today.getFullYear(), today.getMonth(), today.getDate() + 15)
      .toISOString()
      .split("T")[0],
    new Date(today.getFullYear(), today.getMonth(), today.getDate() + 17)
      .toISOString()
      .split("T")[0],
  ]);

  /** Este useEffect se encarga de obtener los destinos administrados desde el panel de administracion */
  useEffect(() => {
    const getDestinations = async () => {
      try {
        const response = await getAllDestinations(2);
        setDestinations(response);
      } catch (error) {
        throw new Error("Error fetching Data. Destinations: " + error);
      }
    };
    getDestinations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="hotels">
      <PrincipalBanner
        idSeccion={2}
        principalTitle="Hoteles a la altura de tu destino"
      />
      <CarouselCards
        title={"Destinos inigualables por conocer"}
        cardsInfo={destinations}
        selectedDates={dates}
        urlService={"/alojamientos"}
        seccion="hoteles"
        subtitle={
          "Los mejores destinos para iniciar un recorrido lleno de nuevas emociones."
        }
      />
      <div className="section-cards container">
        <CarruselHotels idSeccion={2} idTitulo={1} />
      </div>
      <BannerParallax
        img={parallaxHotel}
        title={"Viajar es sentirte parte de tu destino"}
        subtitle={"Descubre el mundo con las colecciones que tenemos para ti."}
      />
      <div className="section-cards container py-0 py-sm-2 py-lg-5">
        <CarruselHotels idSeccion={3} idTitulo={2} />
      </div>
      <div className="section-advice py-5 py-sm-5 py-lg-5">
        <SectionAdvise />
      </div>
      <CheckOutCart
        setAlert={setShowAlert}
        showAlert={showAlert}
        setAlertMessage={"Se agrego una nueva habitación"}
        arrDatos={arrSession}
      />
    </div>
  );
};
